import { render, staticRenderFns } from "./session-breadcrumbs.vue?vue&type=template&id=15960c4a&scoped=true&"
import script from "./session-breadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./session-breadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./session-breadcrumbs.vue?vue&type=style&index=0&id=15960c4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15960c4a",
  null
  
)

export default component.exports